import Layout from "partials/layout";
import React, { useState, useEffect } from "react";
import {
  AboutUsFrame,
  OurCoursesFrame,
  UnlockYourLearningFrame,
  WhatWeOffer,
  UnlockYourLearning,
  UnlockYourFrame,
} from "../frames";
import FaqDropdown from "pages/FooterPages/faq/FaqDropdwon";
import styles from "./studenthome.module.scss";
import { FaUsers } from "react-icons/fa6";
import { FaBookOpen } from "react-icons/fa6";
import { FaPlay } from "react-icons/fa";
// import { ERCInput } from 'components/input'
// import ExperienceCard from 'components/experiencecard'
import CounsellorChatCard from "components/counsellorchatcard";
import { ERCText } from "components/text";
import CountUp from "react-countup";

const StudentHomepage = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [
    <UnlockYourLearningFrame key={0} />,
    <UnlockYourLearning key={1} />,
    <UnlockYourFrame key={2} />,
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prevIndex) => (prevIndex + 1) % slides.length);
    }, 5000); // Change component every 5 seconds

    return () => clearInterval(interval);
  }, [slides.length]);

  const ratings = [
    {
      id: 1,
      icon: FaUsers,
      label: "Students",
      rate: 800000,
    },
    {
      id: 2,
      icon: FaBookOpen,
      label: "Interactive Content",
      rate: 700000,
    },
    {
      id: 3,
      icon: FaPlay,
      label: "Mock Questions",
      rate: 99.9,
    },
    {
      id: 4,
      icon: FaBookOpen,
      label: "Learning Videos",
      rate: 900,
    },
  ];
  const faqs = [
    {
      id: 1,
      question: "What is the Lagos State Education Resource Center?",
      answer:
        "The Lagos State Education Resource Center is a comprehensive online platform aimed at providing educational resources and support to students, teachers, and the community at large. Established in 1967, the Lagos State Education Resource Centre features a library and ICT laboratory for internet access, educational material downloads, exam registration, result checks, and instructional material creation.",
    },
    {
      id: 2,
      question: "Who can access the resources on this platform?",
      answer:
        "The Lagos State Education Resource Center is a comprehensive online platform aimed at providing educational resources and support to students, teachers, and the community at large. Established in 1967, the Lagos State Education Resource Centre features a library and ICT laboratory for internet access, educational material downloads, exam registration, result checks, and instructional material creation.",
    },
    {
      id: 3,
      question: "What type of resources are available on the platform?",
      answer:
        "The Lagos State Education Resource Center is a comprehensive online platform aimed at providing educational resources and support to students, teachers, and the community at large. Established in 1967, the Lagos State Education Resource Centre features a library and ICT laboratory for internet access, educational material downloads, exam registration, result checks, and instructional material creation.",
    },
    {
      id: 4,
      question:
        "Are the resources tailored to specific grade levels or subjects?",
      answer:
        "The Lagos State Education Resource Center is a comprehensive online platform aimed at providing educational resources and support to students, teachers, and the community at large. Established in 1967, the Lagos State Education Resource Centre features a library and ICT laboratory for internet access, educational material downloads, exam registration, result checks, and instructional material creation.",
    },
    {
      id: 5,
      question:
        "How can teachers integrate these resources into their lesson plans?",
      answer:
        "The Lagos State Education Resource Center is a comprehensive online platform aimed at providing educational resources and support to students, teachers, and the community at large. Established in 1967, the Lagos State Education Resource Centre features a library and ICT laboratory for internet access, educational material downloads, exam registration, result checks, and instructional material creation.",
    },
  ];
  return (
    <Layout mqcolor="#00296B">
      <div className="md:px-36 md:py-12 pb-12 bg-[#FEF8D8] w-full">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`${index === currentSlide ? "block" : "hidden"}`}
          >
            {slide}
          </div>
        ))}
        <div className="flex justify-center md:mt-12 space-x-2">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)} // Navigate to specific slide
              className={`h-[24px] w-[24px] flex justify-center items-center rounded-full ${
                index === currentSlide ? "border-4 border-secondary" : ""
              }`}
            >
              <span className="w-[8px] h-[8px] rounded-full bg-secondary"></span>
            </button>
          ))}
        </div>
      </div>
     <section className="bg-primary w-full overflow-hidden">
  <main className="max-w-6xl mx-auto py-12 md:py-16">
    {/* Mobile: auto-scrolling marquee */}
    <div className="md:hidden group">
      <div className="flex w-max animate-marquee group-active:[animation-play-state:paused] motion-reduce:animate-none motion-reduce:flex-wrap motion-reduce:w-full motion-reduce:justify-center motion-reduce:gap-8 motion-reduce:px-6">
        {[...ratings, ...ratings].map((rating, i) => (
          <div className="flex items-center gap-4 px-8" key={`${rating.id}-${i}`}>
            <div className="flex-shrink-0 p-5 rounded-full bg-[#F6F5B2]">
              {rating.icon && <rating.icon className="text-secondary w-8 h-8" />}
            </div>
            <div className="flex flex-col font-inter gap-1 text-[#1D2026] whitespace-nowrap">
              <h2 className="text-[28px] font-bold leading-8">
                <CountUp delay={0.5} end={rating.rate} />+
              </h2>
              <p className="text-[#0C0C0C] font-medium text-sm leading-5">
                {rating.label}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>

    {/* Desktop: static row */}
    <div className="hidden md:flex md:items-center md:justify-between px-8 lg:px-8 divide-x divide-black/10">
      {ratings.map((rating) => (
        <div className="flex items-center gap-4 px-8 first:pl-0 last:pr-0" key={rating.id}>
          <div className="flex-shrink-0 p-5 rounded-full bg-[#F6F5B2]">
            {rating.icon && <rating.icon className="text-secondary w-8 h-8" />}
          </div>
          <div className="flex flex-col font-inter gap-1 text-[#1D2026]">
            <h2 className="text-[28px] font-bold leading-8">
              <CountUp delay={0.5} end={rating.rate} />+
            </h2>
            <p className="text-[#0C0C0C] font-medium text-sm leading-5">
              {rating.label}
            </p>
          </div>
        </div>
      ))}
    </div>
  </main>
</section>
      <section className={styles.aboutusframe}>
        <AboutUsFrame />
      </section>

      <section className={styles.coursesdiv}>
        <OurCoursesFrame />
      </section>

      <WhatWeOffer />

      <section className={styles.chat}>
        <CounsellorChatCard />
      </section>

      <section className="md:p-24 p-6 flex justify-center items-center flex-col gap-12  text-[#1D2026]">
        <ERCText size="40px" lHeight="48px"  color="#00296B" weight="700">
          Frequently Asked Questions
        </ERCText>
        <div className="md:w-2/4 w-full  flex flex-col gap-6">
          {faqs.map((data) => (
            <FaqDropdown
              key={data.id}
              smallText={data.answer}
              header={data.question}
            />
          ))}
        </div>
      </section>
    </Layout>
  );
};

export default StudentHomepage;
